import { styled } from "styled-components";
const TabMenuWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  position: "absolute",
  right: 6,
  top: "50%",
  transform: "translateY(-50%)",
  zIndex: 20
});
export {
  TabMenuWrapper
};
